import script from "./PortfolioSection.vue?vue&type=script&setup=true&lang=js"
export * from "./PortfolioSection.vue?vue&type=script&setup=true&lang=js"

import "./PortfolioSection.vue?vue&type=style&index=0&id=35ac5db0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-35ac5db0"]])

export default __exports__